import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ['markersLayer', 'sidebar']

  toggle(event) {
    this.markersLayerTarget.classList.toggle('hidden')
    this.sidebarTarget.classList.toggle('hidden')
    const isOpen = !this.sidebarTarget.classList.contains('hidden')
    event.currentTarget.classList.toggle('active', isOpen)

    const overlay = this.markersLayerTarget.closest('.wrapper')?.querySelector('.overlay')
    if (!overlay) return

    if (isOpen) {
      overlay.dataset.proposedPlacementId = this.sidebarTarget.dataset.proposedPlacementId
    } else {
      delete overlay.dataset.proposedPlacementId
    }
  }

  switchTier(event) {
    const select = event.currentTarget
    const proposedId = select.value

    const overlay = this.markersLayerTarget.closest('.wrapper')?.querySelector('.overlay')
    if (overlay && !this.sidebarTarget.classList.contains('hidden')) {
      overlay.dataset.proposedPlacementId = proposedId
    }
    this.sidebarTarget.dataset.proposedPlacementId = proposedId
    const startFresh = this.sidebarTarget.querySelector('.proposed-start-fresh')
    if (startFresh) startFresh.dataset.proposedPlacementId = proposedId

    this.stimulate('ProposedPlacementReflex#switch_tier', select, proposedId)
  }
}
